import React, { useState } from 'react'
import { type Track, useTrack } from '../../../webrtc/webRTCRoom'
import { useSelectedAudioOutputDevice } from '../../../Devices/useDevices'
import { getRole } from '../../../global/blocs/roomInfo'

import './VideoTrack.scss'

interface VideoTrackProps {
  track: Track
  objectFit?: 'cover' | 'contain'
}

const VideoTrack = ({ track, objectFit = 'contain' }: VideoTrackProps) => {
  const audioOutputDeviceId = useSelectedAudioOutputDevice()
  const role = getRole()
  const [videoRef, setVideoRef] = useState<HTMLVideoElement | null>(null)
  useTrack(track, videoRef)

  const isMuted =
    ((role === 'presenter' || role === 'producer') && !audioOutputDeviceId) ||
    !track.isEnabled

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      muted={isMuted}
      disablePictureInPicture
      ref={setVideoRef}
      playsInline
      style={{
        display: 'block',
        height: '100%',
        width: '100%',
        objectFit,
      }}
    />
  )
}

export { VideoTrack }
